import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

type EyebrowProps = {
    children: ReactNode
    className?: string
}

/**
 * The small capsule that labels each section: "Our Clients", "Results",
 * "Services", and so on.
 */
export const Eyebrow = ({ children, className }: EyebrowProps) => {
    return (
        <span
            className={cn(
                'inline-flex items-center justify-center rounded-xl bg-[#111] px-3 py-2 text-sm leading-none font-medium tracking-[-0.02em] text-[#fcfcfa] ring-1 ring-white/10 backdrop-blur-[5px] sm:px-4 sm:py-3 sm:text-base',
                className
            )}
        >
            {children}
        </span>
    )
}
